import { useCallback, useEffect } from 'react';

import { InputField, PhoneField } from '@components';
import { isValidEmail } from '@utils';
import { handleRenderError, withErrorHandler } from '@utils/errorHandler';

interface IBillingDetailsFormProperties {
  attendeeDetails: IAttendee;
  onSubmit?: (event: React.FormEvent) => void;
  setAttendeeDetails: (attendeeDetails: IAttendee) => void;
  setBlocked: (blocked: boolean) => void;
}

export const BillingDetailsForm = ({
  attendeeDetails,
  onSubmit,
  setAttendeeDetails,
  setBlocked,
}: IBillingDetailsFormProperties) => {
  try {
    const checkFormEntriesValid = useCallback(
      withErrorHandler(() => {
        if (
          attendeeDetails.FirstName?.trim() === '' ||
          attendeeDetails.LastName?.trim() === '' ||
          !isValidEmail(attendeeDetails.Email) ||
          attendeeDetails.Phone?.trim() === ''
        ) {
          return setBlocked(true);
        }
        return setBlocked(false);
      }),
      [attendeeDetails, setBlocked]
    );

    useEffect(() => {
      checkFormEntriesValid();
    }, [checkFormEntriesValid]);

    return (
      <form className='formContactDetails' onSubmit={onSubmit}>
        <div className='form-row form-row-double' id='addAttendeeNameRow'>
          <InputField
            type='text'
            id='firstName'
            name='firstName'
            label='First Name'
            value={attendeeDetails.FirstName}
            onChange={uiEvent => {
              const target = uiEvent.target as HTMLTextAreaElement;
              setAttendeeDetails({
                ...attendeeDetails,
                FirstName: target?.value ?? '',
              });
            }}
            required
          />
          <InputField
            type='text'
            id='lastName'
            name='lastName'
            label='Last Name'
            value={attendeeDetails.LastName}
            onChange={uiEvent => {
              const target = uiEvent.target as HTMLTextAreaElement;
              setAttendeeDetails({
                ...attendeeDetails,
                LastName: target?.value ?? '',
              });
            }}
            required
          />
        </div>
        <div className='form-row' id='addAttendeeEmailRow'>
          <InputField
            type='email'
            id='email'
            name='email'
            label='Email'
            value={attendeeDetails.Email}
            onChange={uiEvent => {
              const target = uiEvent.target as HTMLTextAreaElement;
              setAttendeeDetails({
                ...attendeeDetails,
                Email: target?.value ?? '',
              });
            }}
            required
          />
        </div>
        <div className='form-row' id='addAttendeePhoneRow'>
          <PhoneField
            id='phone'
            name='phone'
            label='Phone'
            value={attendeeDetails.Phone}
            onChange={Phone => {
              setAttendeeDetails({
                ...attendeeDetails,
                Phone,
              });
            }}
          />
        </div>
        <input type='submit' hidden />
      </form>
    );
  } catch (error) {
    return handleRenderError(error);
  }
};
